import { useQuery } from "@tanstack/react-query";

import { ListRedeterminationsFilterType } from "@/domain/redeterminations";

import { RedeterminationsApi } from "../api/redeterminationsApi";

export const RedeterminationsQueryKeys = {
  all: ["redeterminations"] as const,
  list: (filters?: ListRedeterminationsFilterType) =>
    filters
      ? ([...RedeterminationsQueryKeys.all, "list", { filters }] as const)
      : ([...RedeterminationsQueryKeys.all, "list"] as const),
  details: (redeterminationId: string) =>
    [...RedeterminationsQueryKeys.all, redeterminationId] as const,
};

type ListRedeterminationsParamsType = {
  filters: ListRedeterminationsFilterType;
  isEnabled?: boolean;
};

export const useListRedeterminationsQuery = ({
  filters,
  isEnabled,
}: ListRedeterminationsParamsType) => {
  return useQuery({
    queryKey: RedeterminationsQueryKeys.list(filters),
    queryFn: () => RedeterminationsApi.listRedeterminations(filters),
    enabled: isEnabled,
  });
};

export const useGetRedeterminationQuery = (redeterminationId: string) => {
  return useQuery({
    queryKey: RedeterminationsQueryKeys.details(redeterminationId),
    queryFn: () => RedeterminationsApi.getRedetermination(redeterminationId),
    enabled: Boolean(redeterminationId),
  });
};
